<template>
  <div class="flex" :class="alignTextClass">
    <div class="loader" :class="spinnerColorClass">
      <i class="chklodr" :class="spinnerIconClass"  :style="{ border: `3px dotted ${spinnerColor || '#29abe2'}` ,width:`${spinnerWidth} !important` , height:`${spinnerHeight} !important`}"></i>
    </div>
    <span class="ml-2" :style="{ color: textColor }">{{ $t(loadingText) }}</span>
  </div>
</template>

<script>
export default {
  name: 'vs-spinner',
  props: {
    loadingText: {
      type: String,
      default: 'Loading',
    },
    spinnerColorClass: {
      type: String,
      default: '', //loaderchklodrblue
    },
    spinnerColor: {
      type: String,
      default: '#29abe2', // Allows users to specify a custom color (e.g., #ff0000 or red)
    },
    textColor: {
      type: String,
      default: '#666',
    },
    spinnerIconClass: {
      type: String,
      default: '',
    },
    spinnerWidth:{
      type:String,
      default:'16px',
    },
    spinnerHeight:{
      type:String,
      default:'16px',
    },
    alignTextClass:{
      type:String,
      default:'justify-center items-center text-center',
    }
  },
};
</script>

<style scoped>
.loader {
  display: inline-block;
  position: relative;
}

.chklodr {
  display: inline-block;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
